<div class="form-block">

  <mat-label>Add variants</mat-label>
  <mat-selection-list color="primary" (selectionChange)="onSelectionChange($event)">
    <mat-list-option togglePosition="before" value="origin" [selected]="isSelectedOriginStream">Original Stream</mat-list-option>
    <mat-list-option *ngFor="let transcoding of streamTranscodings"
                     togglePosition="before"
                     [value]="transcoding.id"
                     [selected]="isSelectedTranscoding(transcoding.id)"
    >
      {{transcoding.name}}
    </mat-list-option>
  </mat-selection-list>
</div>
